import { createKeyboardEvent } from "./keyboard";

let ir = null;

const BRIGHTSIGN_IR_CODE_MAP = {
  7311382: "Power",
  7311378: "ArrowUp",
  7311379: "ArrowDown",
  7311376: "ArrowLeft",
  7311377: "ArrowRight",
  7311380: "Enter",
  7311383: "Home",
  7311375: "Mute",
  7311381: "Back",
  7311424: "VolumeUp",
  7311425: "VolumeDown",
};


export default function initRemoteControl() {
  let raf = null;
  let pending = null;
  let lastTime = 0;
  const LIMIT_MS = 100;
  const INITIAL_DELAY_MS = 300;
  const REPEAT_MS = 100;
  let isRepeating = false;

  const normalizeKey = (k) => {
    switch (k) {
      case "Up": return "ArrowUp";
      case "Down": return "ArrowDown";
      case "Left": return "ArrowLeft";
      case "Right": return "ArrowRight";
      case "Select": return "Enter";
      default: return k;
    }
  };

  const isArrowKey = (key) => key === "ArrowUp" || key === "ArrowDown" || key === "ArrowLeft" || key === "ArrowRight";

  const send = (key) => {
    const ev = createKeyboardEvent(key);
    window.dispatchEvent(ev);
  };

  const flush = () => {
    raf = null;
    const k = pending;
    pending = null;
    if (!k) return;

    const now = performance.now();
    if (now - lastTime >= LIMIT_MS) {
      lastTime = now;
      send(k);
    }
  };

  function handleMessage({ data }) {
    if (!data || data.type !== "tvremote") return;

    const keyNorm = normalizeKey(data.key);

    if (isArrowKey(keyNorm)) {
      pending = keyNorm;
      if (raf == null) raf = requestAnimationFrame(flush);
      return;
    }

    send(keyNorm);
  }
  const hasBSIR = typeof BSIRReceiver !== "undefined";
  if (hasBSIR && !ir) {
    try {
      ir = new BSIRReceiver("IR-in", "NEC");
      ir.onremotedown = (event) => {
        isRepeating = false;
        const key = BRIGHTSIGN_IR_CODE_MAP[event.code];
        if (!key) return;
        lastTime = performance.now();
        send(key);
      };
      ir.onremoterepeat = (event) => {
        const key = BRIGHTSIGN_IR_CODE_MAP[event.code];
        if (!key || !isArrowKey(key)) return;
        const now = performance.now();
        const delay = isRepeating ? REPEAT_MS : INITIAL_DELAY_MS;
        if (now - lastTime >= delay) {
          isRepeating = true;
          lastTime = now;
          send(key);
        }
      };
    } catch (e) {
      console.error("BSIRReceiver init failed:", e);
    }
  } else {
    window.addEventListener("message", handleMessage);
  }
}
